import React, { useEffect, useRef } from 'react';
import { bool, string } from 'prop-types';
import clsx from 'clsx';
import useStore from 'state/state';
import { useSpring, animated } from 'react-spring';
import NewWindowIcon from 'assets/images/icons/new-window-icon.svg';

import styles from './Document.module.scss';

const Document = ({
  isWhitePaper,
  isFirstChild,
  imageRight,
  category,
  title,
  description,
  imgUrl,
  url,
  animateOut,
}) => {
  const firstChildRef = useRef();
  const setAnimatedBoxEndPosition = useStore(
    (state) => state.setAnimatedBoxEndPosition
  );

  const appData = useStore((state) => state.appData);

  useEffect(() => {
    if (firstChildRef.current) {
      const firstChildPosition = firstChildRef.current.getBoundingClientRect();
      setAnimatedBoxEndPosition(firstChildPosition);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const props = useSpring({
    to: {
      top: isWhitePaper ? '42px' : '-42px',
      left: '0px',
    },
    from: {
      top: '0px',
      left: '488px',
    },
    config: {
      friction: 20,
      tension: 175,
      mass: 1.5,
    },
    delay: 500,
  });

  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.isWhitePaper]: !isWhitePaper,
        [styles.imageRight]: imageRight,
      })}
    >
      {!isFirstChild ? (
        <div
          className={clsx(styles.image, styles.slideIn, {
            [styles.isWhitePaper]: isWhitePaper,
            [styles.fadeOut]: animateOut,
          })}
        >
          <img src={imgUrl} alt="" />
        </div>
      ) : (
        <animated.div
          style={props}
          className={clsx(styles.image, styles.firstChild, {
            [styles.isWhitePaper]: isWhitePaper,
            [styles.fadeOut]: animateOut,
          })}
        >
          <img src={imgUrl} alt="" />
        </animated.div>
      )}
      <div
        ref={isFirstChild ? firstChildRef : null}
        className={clsx(styles.content, {
          [styles.fadeOut]: animateOut,
          [styles.firstChild]: isFirstChild,
          [styles.slideIn]: !isFirstChild,
        })}
      >
        <span className={styles.preheader}>{category}</span>
        <h3
          className={clsx(styles.header, {
            [styles.small]: title.length > 65,
          })}
        >
          {title}
        </h3>
        <p className={styles.description}>{description}</p>
        <a rel="noreferrer" target="_blank" href={url}>
          <div className={styles.icon}>
            <NewWindowIcon />
          </div>
          <span> {appData.mainData.overallApp.readMoreText}</span>
        </a>
      </div>
    </div>
  );
};

Document.propTypes = {
  isWhitePaper: bool,
  imageRight: bool,
  category: string,
  title: string,
  description: string,
  imgUrl: string,
  url: string,
  isFirstChild: bool,
  animateOut: bool,
};

Document.defaultProps = {
  isWhitePaper: false,
  imageRight: false,
  category: null,
  title: null,
  description: null,
  imgUrl: null,
  url: null,
  isFirstChild: false,
  animateOut: false,
};

export default Document;
